// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import { initMixpanel, setupClickTracking } from '../utilities/mixpanel'

Rails.start()
ActiveStorage.start()

// Global JS extensions
require('utilities/cable_ready')
require('utilities/confirmation_success')
require('utilities/hiding')
require('utilities/html_to_elements')
require('utilities/set')
require('utilities/trix')

// ActionText support
require("trix")
require("@rails/actiontext")

// Enable Datatables
require('datatables.net-dt');
require('datatables.net-buttons-dt');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-colreorder-dt');

// Load up Turbo & Stimulus controllers
import "controllers"

// Enable fancy date & time pickers in forms
import '../components/date_time_picker'

// Enable charts
import 'chartkick/chart.js'
import { Chart, LinearScale, PointElement } from 'chart.js'
window.Chart = Chart
import 'chartjs-adapter-date-fns'
import annotationPlugin from 'chartjs-plugin-annotation'
import { TreeController, EdgeLine } from 'chartjs-chart-graph';

Chart.register(annotationPlugin, TreeController, EdgeLine, LinearScale, PointElement);

// Handle missing turbo frame content
document.addEventListener("turbo:frame-missing", function(event) {
  event.preventDefault(); // Prevent default error behavior
  
  const frameElement = event.target;
  const frameUrl = event.detail.response?.url || frameElement.src;
  const isDevelopment = window.location.hostname === "localhost" || 
                        window.location.hostname === "127.0.0.1" ||
                        window.location.hostname.includes(".local");
  
  // Store original dimensions
  const originalHeight = frameElement.offsetHeight || 150;
  const originalWidth = frameElement.offsetWidth || 300;
  
  // Add a class to the frame element to enable 100% height
  frameElement.classList.add("frame-missing");
  
  // Create a user-friendly error message with refresh link
  const messageContainer = document.createElement("div");
  messageContainer.classList.add("frame-missing-message");
  
  // Add small-container class for smaller frames
  if (originalWidth < 400 && originalHeight < 400) {
    messageContainer.classList.add("small-container");
  }
  
  // Clear the frame content
  frameElement.innerHTML = "";
  
  // Add the message container to the frame
  frameElement.appendChild(messageContainer);
  
  let messageHTML = '';
  
  // Only add server down image for larger containers
  if (originalWidth >= 400 || originalHeight >= 400) {
    // Use the serverDownImageUrl provided by Rails in the header
    messageHTML += `
      <div class="placeholder-image">
        <img src="${window.serverDownImageUrl}" alt="Server issue">
      </div>
    `;
  }
  
  // Add the message text
  messageHTML += `
    <div class="message-content">
      <p>We had an issue loading this part of the page.</p>
      <p class="small">Our team has been notified. You can try <a href="#" class="refresh-link">refreshing</a> in the meantime.</p>
    </div>
  `;
  
  // Add developer link in development mode
  if (isDevelopment && frameUrl) {
    messageHTML += `
      <div class="dev-tools">
        <p class="dev-note">Development Mode</p>
        <a href="javascript:void(0)" class="dev-link" data-url="${frameUrl}">Open in new tab for Better Errors</a>
      </div>
    `;
  }
  
  // Set the HTML content
  messageContainer.innerHTML = messageHTML;
  
  // Add event listener for the refresh link
  const refreshLink = messageContainer.querySelector(".refresh-link");
  refreshLink.addEventListener("click", function(e) {
    e.preventDefault(); // Prevent default anchor behavior
    e.stopPropagation(); // Stop event bubbling
    // Reload the current page
    window.location.reload();
  });
  
  // Add event listener for the dev link if it exists
  const devLink = messageContainer.querySelector(".dev-link");
  if (devLink) {
    devLink.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation(); // Stop event bubbling
      e.stopImmediatePropagation(); // Prevent other listeners on the same element
      
      // Force open in a new tab via JavaScript
      const url = this.getAttribute("data-url");
      if (url) {
        window.open(url, "_blank");
      }
      
      return false;
    }, true); // Use capture phase to ensure this runs before other listeners
  }
  
  // Optional: Log the error for monitoring
  console.warn("Turbo frame missing:", frameElement.id, "Original dimensions:", originalWidth, "x", originalHeight, "URL:", frameUrl);
});

// Page title tracking removed - back buttons now use explicit titles

// Initialize Mixpanel when the DOM is loaded
document.addEventListener("turbo:load", function() {
  // Initialize Mixpanel
  if (initMixpanel()) {
    // Set up click tracking
    setupClickTracking()
  }
})

// Handle anchor scrolling after Turbo Frame loads
document.addEventListener("turbo:frame-load", function(event) {
  if (window.location.hash) {
    const hash = window.location.hash.slice(1)
    const element = document.getElementById(hash)
    
    if (element) {
      // Check if the element is within the frame that just loaded
      if (event.target.contains(element)) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" })
          // Drop the hash from the URL after scrolling to prevent future automatic scrolling
          const url = new URL(window.location)
          url.hash = ""
          history.replaceState({}, "", url)
        }, 100)
      }
    }
  }
})

// Welcome message!
console.log('\\ \\ / /__  __ _ _ __ / _ \\ _ __   ___ ')
console.log(' \\ V / _ \\/ _` | \'__| | | | \'_ \\ / _ \\')
console.log('  | |  __/ (_| | |  | |_| | | | |  __/')
console.log('  |_|\\___|\\__,_|_|   \\___/|_| |_|\\___|')
console.log("Hello, code spelunker! Welcome to YearOne!")
console.log("\n\n")
